function diferenceBetweenTimes(cas1, cas2) {
    // Časový rozdíl v milisekundách
  const rozdilVMilisekundach = new Date(`1970-01-01T${cas2}`) - new Date(`1970-01-01T${cas1}`);

  // Převod rozdílu na minuty a zaokrouhlení na celé minuty
  const rozdilVMINutach = Math.round(rozdilVMilisekundach / (1000 * 60));

  return rozdilVMINutach;
  }

export default diferenceBetweenTimes
